export enum RouterEnum {
  FamilyMembers = 'family-members',
  Basket = 'basket',
  Payment = 'payment',
}
